module.exports = __webpack_public_path__ + "836658335b9c3cb9894d6f07e3c1dbdd.png";